import { getAnalytics, isSupported, logEvent, type Analytics } from 'firebase/analytics';
import getFirebaseApp from '../firebase';

let analyticsInstance: Analytics | null | undefined;

async function getWebsiteAnalytics(): Promise<Analytics | null> {
  if (analyticsInstance !== undefined) return analyticsInstance;

  if (!process.env.REACT_APP_FIREBASE_MEASUREMENT_ID) {
    analyticsInstance = null;
    return null;
  }

  try {
    if (!(await isSupported())) {
      analyticsInstance = null;
      return null;
    }
    analyticsInstance = getAnalytics(getFirebaseApp());
    return analyticsInstance;
  } catch {
    analyticsInstance = null;
    return null;
  }
}

export type WebsiteClickButton = 'download_nav' | 'app_store' | 'google_play' | 'privacy_policy';
export type WebsiteClickSection = 'header' | 'hero' | 'cta' | 'footer';

export function trackWebsiteClick(button: WebsiteClickButton, section: WebsiteClickSection): void {
  void (async () => {
    const analytics = await getWebsiteAnalytics();
    if (!analytics) return;

    logEvent(analytics, 'website_click', { button, section });
  })();
}
